export default __webpack_public_path__ + "static/benefitSectionBg-443ab9d0d1e94720a9a192d917643816.png";